import { badgeDisabled, badgeEnabled } from "../LensRowBadge.styles";
import {
    BadgeContentBothProgramsActive,
    BadgeContentBothProgramsEligible,
    BadgeContentExclusiveLensEligible,
    BadgeContentExclusiveLensExclusive,
    BadgeContentExclusiveLensIneligible,
    BadgeContentExclusiveLensRemoved,
    BadgeContentLensCreatorPayoutEligible,
    BadgeContentLensCreatorPayoutIneligible,
    BadgeContentLensCreatorPayoutPending,
    BadgeContentMixedProgramStatus,
    BadgeTitleBothProgramsActive,
    BadgeTitleBothProgramsEligible,
    BadgeTitleExclusiveLensEligible,
    BadgeTitleExclusiveLensExclusive,
    BadgeTitleExclusiveLensIneligible,
    BadgeTitleExclusiveLensRemoved,
    BadgeTitleLensCreatorPayoutEligible,
    BadgeTitleLensCreatorPayoutIneligible,
    BadgeTitleLensCreatorPayoutPending,
    BadgeTitleMixedProgramStatus,
} from "../messages.generated";

import { ExclusiveLensStatus, LensCreatorPayoutEligibility } from "src/app/gql-generated/types";

export interface BadgeConfig {
    title: React.ReactElement;
    content: React.ReactElement;
    badgeClass: string;
    badgeIcon: string;
    includeNote?: boolean;
}

// Individual program configurations
export const EXCLUSIVE_LENS_CONFIGS: Record<ExclusiveLensStatus, BadgeConfig | null> = {
    [ExclusiveLensStatus.ExclusiveLensStatusExclusive]: {
        title: <BadgeTitleExclusiveLensExclusive />,
        content: <BadgeContentExclusiveLensExclusive note={undefined} />,
        badgeClass: badgeEnabled,
        badgeIcon: "$",
        includeNote: true,
    },
    [ExclusiveLensStatus.ExclusiveLensStatusEligible]: {
        title: <BadgeTitleExclusiveLensEligible />,
        content: <BadgeContentExclusiveLensEligible note={undefined} />,
        badgeClass: badgeDisabled,
        badgeIcon: "$",
        includeNote: true,
    },
    [ExclusiveLensStatus.ExclusiveLensStatusIneligible]: {
        title: <BadgeTitleExclusiveLensIneligible />,
        content: <BadgeContentExclusiveLensIneligible />,
        badgeClass: badgeDisabled,
        badgeIcon: "$",
    },
    [ExclusiveLensStatus.ExclusiveLensStatusRemoved]: {
        title: <BadgeTitleExclusiveLensRemoved />,
        content: <BadgeContentExclusiveLensRemoved />,
        badgeClass: badgeDisabled,
        badgeIcon: "$",
    },
    [ExclusiveLensStatus.ExclusiveLensStatusUnset]: null,
};

export const LENS_CREATOR_REWARDS_CONFIGS: Record<LensCreatorPayoutEligibility, BadgeConfig | null> = {
    [LensCreatorPayoutEligibility.LensCreatorPayoutEligibilityEligible]: {
        title: <BadgeTitleLensCreatorPayoutEligible />,
        content: <BadgeContentLensCreatorPayoutEligible note={undefined} />,
        badgeClass: badgeEnabled,
        badgeIcon: "$",
        includeNote: true,
    },
    [LensCreatorPayoutEligibility.LensCreatorPayoutEligibilityPending]: {
        title: <BadgeTitleLensCreatorPayoutPending />,
        content: <BadgeContentLensCreatorPayoutPending note={undefined} />,
        badgeClass: badgeDisabled,
        badgeIcon: "$",
        includeNote: true,
    },
    [LensCreatorPayoutEligibility.LensCreatorPayoutEligibilityIneligible]: {
        title: <BadgeTitleLensCreatorPayoutIneligible />,
        content: <BadgeContentLensCreatorPayoutIneligible />,
        badgeClass: badgeDisabled,
        badgeIcon: "$",
    },
    [LensCreatorPayoutEligibility.LensCreatorPayoutEligibilityUnset]: null,
};

// Combined program configurations
export const COMBINED_PROGRAM_CONFIGS = {
    bothActive: {
        title: <BadgeTitleBothProgramsActive />,
        content: <BadgeContentBothProgramsActive note={undefined} />,
        badgeClass: badgeEnabled,
        badgeIcon: "$",
        includeNote: true,
    },
    bothEligible: {
        title: <BadgeTitleBothProgramsEligible />,
        content: <BadgeContentBothProgramsEligible note={undefined} />,
        badgeClass: badgeDisabled,
        badgeIcon: "$",
        includeNote: true,
    },
    bothIneligible: {
        title: <BadgeTitleMixedProgramStatus />,
        content: (
            <BadgeContentMixedProgramStatus
                exclusiveStatus="Lens+ Payouts Ineligible"
                rewardsStatus="Top Performer Payouts Ineligible"
                note={undefined}
            />
        ),
        badgeClass: badgeDisabled,
        badgeIcon: "$",
        includeNote: false,
    },
} as const;
